import { useIntl } from "react-intl-compat";
import { AMENITIES_GROUP_BY_USE_TYPE } from "~/app/your-space/activate-listings/ActivateListingsPage.consts";
import { useGetListingAmenitiesQuery } from "~/services/env.service";

import type { ListingUseType } from "../../../../components/src/services/listings.service";
import { useGetListingQuery } from "../../../../components/src/services/listings.service";
import { useGetSpaceQuery } from "../../../../components/src/services/spaces.service";

type UseListingDetailsDataArgs = {
  listingId: string;
};

/**
 * SpacesAPI has no endpoint keyed by listing id (every space route is keyed
 * by `:spaceId` — confirmed against spaces_app.js), so the parent space is
 * fetched in a second step once the listing tells us its `parentSpaceId`.
 */
const useListingDetailsData = ({ listingId }: UseListingDetailsDataArgs) => {
  const intl = useIntl();

  const { data: listing, isFetching: isListingFetching } = useGetListingQuery({
    listingId,
  });

  const parentSpaceId = listing?.parentSpaceId;

  const { data: space, isFetching: isSpaceFetching } = useGetSpaceQuery(
    { spaceId: parentSpaceId ?? "" },
    { skip: !parentSpaceId },
  );

  const { data: amenitiesResponse, isFetching: isAmenitiesFetching } =
    useGetListingAmenitiesQuery({ locale: intl.locale });

  const amenityOptions = amenitiesResponse
    ? amenitiesResponse.amenities[
        AMENITIES_GROUP_BY_USE_TYPE[listing?.use_type as ListingUseType]
      ]
    : undefined;

  return {
    listing,
    space,
    amenityOptions,
    isFetching: isListingFetching || isSpaceFetching || isAmenitiesFetching,
  };
};

export { useListingDetailsData };
